const CSV_FORMULA_PREFIX_PATTERN = /^[=+\-@]/;

export const csvEscapeCell = (value: unknown): string => {
  if (value === null || value === undefined) return '""';

  let text = '';
  if (typeof value === 'string') {
    text = value;
  } else if (typeof value === 'number' || typeof value === 'boolean') {
    text = String(value);
  } else if (Array.isArray(value)) {
    text = value.map((entry) => (entry == null ? '' : String(entry))).join(' | ');
  } else {
    text = JSON.stringify(value);
  }

  // Mitigate spreadsheet formula injection.
  if (CSV_FORMULA_PREFIX_PATTERN.test(text)) {
    text = `'${text}`;
  }

  return `"${text.replace(/"/g, '""')}"`;
};

export const buildCsvContent = (headers: string[], rows: unknown[][]): string => {
  const headerLine = headers.map(csvEscapeCell).join(',');
  const bodyLines = rows.map((row) => row.map(csvEscapeCell).join(','));
  return [headerLine, ...bodyLines].join('\n');
};

const buildCsvFilename = (prefix: string): string => {
  const safePrefix = prefix.trim().length > 0 ? prefix.trim() : 'export';
  const timestamp = new Date().toISOString().replace(/[:]/g, '-').replace(/\..+$/, '');
  return `${safePrefix}_${timestamp}.csv`;
};

export const downloadCsv = (filenamePrefix: string, csvContent: string): void => {
  const filename = buildCsvFilename(filenamePrefix);
  const blob = new Blob(['\uFEFF', csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.setAttribute('href', url);
  link.setAttribute('download', filename);
  link.click();
  URL.revokeObjectURL(url);
};
